
  import AvailabilitySlots from '@/mixins/AvailabilitySlots';

  export default {
    name: 'AvailabilitySlotList',
    mixins: [AvailabilitySlots],
    props: {
      slots: {
        type: Array,
        required: false,
        default: () => [],
      },
      // Vergangene Termine ausgrauen (statt ausblenden).
      grayPast: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    computed: {
      orderedSlots() {
        return this.sortSlots(this.slots);
      },
    },
  };
